import { Controller } from "@hotwired/stimulus";
import { get } from '@rails/request.js'

export default class extends Controller {
  static values = { url: String }

  loadErrors(e) {
    e.preventDefault();
    if (!this.urlValue) {
      console.error("log-batch-errors: url value is missing");
      return;
    }

    const dialog = document.querySelector('dialog#logBatchErrorsModal');
    get(this.urlValue, { responseKind: 'turbo-stream' }).catch(error => {
      console.error("Error fetching data:", error);
    });
    dialog.dataset.dialogMode = 'dialog';
    dialog.show();
  }
}
